"use strict";
{
  const storedIgnoreCollectionProductIds = JSON.parse(
    sessionStorage.getItem("ignoreCollectionProductIds")
  );

  class AddonProduct {
    constructor({ main, collectionsIgnoreProductsArr }) {
      this.settings = {
        id: main.id,
        variantId: main.variantId,
        cart: null,
        ignoreProductIds: main.ignoreProductIds,
        ignoreCollectionsProductsIds: collectionsIgnoreProductsArr,
      };

      this.EventListeners();
      this.GetCartObj();
    }

    Init() {
      this.settings.ignoreProductIds = [...new Set([...this.settings.ignoreProductIds,...this.settings.ignoreCollectionsProductsIds])];
      if (this.settings.cart) {
        // Check if the addon product is in the cart
        const addonProductIsInCart = this.CheckAddonProductInCart();

        if (this.CheckIfAllCartItemsIsOnIgnoreList() === false) {
          // If not in cart, add it
          if (!addonProductIsInCart) {
            // Add Product
            this.AddProduct();
          }
        } else if (addonProductIsInCart) {
          // remove this item
          this.RemoveProduct();
        }
      }
    }

    EventListeners() {
      document.addEventListener("product:added", () => {
        this.GetCartObj();
      });

      document.addEventListener("cart:item:removed", (e) => {
        this.settings.cart = e.detail;
        this.Init();
      });
    }

    GetCartObj() {

      fetch(`${window.Shopify.routes.root}cart.js`)
        .then((response) => response.json())
        .then((data) => {
          this.settings.cart = data;

          this.Init();
        });
    }

    CheckAddonProductInCart() {
      const addonProductInCart = this.settings.cart.items.find(
        (x) => x.product_id === this.settings.id
      );

      if (addonProductInCart && addonProductInCart.quantity > 1) {
        this.RemoveProduct(true);
      }

      return addonProductInCart;
    }

    GetCartProductIdsArr(cartObject) {
      const cartProductIdsArr = cartObject.items.map((x) => x.product_id);
      if (cartProductIdsArr) return cartProductIdsArr;

      return [];
    }

    CheckIfAllCartItemsIsOnIgnoreList() {
      const cartProductIdsArr = this.GetCartProductIdsArr(this.settings.cart);
      return cartProductIdsArr.every((id) =>
        this.settings.ignoreProductIds.includes(id)
      );
    }

    RemoveProduct(reduceToOne = false) {
      if (this.error) return;

      const data = {};
      data[this.settings.variantId] = reduceToOne ? 1 : 0;

      const formData = { updates: data };

      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.settings.cart = data;

          if (!reduceToOne) {
            setTimeout(() => {
              document.documentElement.dispatchEvent(
                new CustomEvent("cart:refresh", {
                  bubbles: true,
                })
              );
            }, 350);
          } else {
            this.Init();
          }
        })
        .catch((error) => {
          this.error = true;
          console.error("Error:", error);
        });
    }

    AddProduct() {
      const formData = { items: [] };

      formData.items.push({
        id: Number(this.settings.variantId),
        quantity: 1,
      });

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          setTimeout(() => {
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:refresh", {
                bubbles: true,
              })
            );
          }, 0);
          this.GetCartObj();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  }

  class getIgnoreProductsFromCollections {
    constructor() {
      this.options = {};
      this.data = {};
      this.collections = window.addonProduct.ignoreCollections;
      this.ignoreProducts = [];
      this.init();
    }

    async init() {
      try {
        await this.getRequestUrls();
        await this.saveToSesseion();
      } catch (e) {
        console.error(e);
      }

      new AddonProduct({
        main: window.addonProduct,
        collectionsIgnoreProductsArr: this.ignoreProducts,
      });
    }

    async getRequestUrls() {
      const urlArr = [];
      this.collections.forEach((collection) => {
        const collectionPageCount = Math.ceil(collection.count / 50);
        /**Get all available urls */
        if (collectionPageCount > 0) {
          for (let i = 1; i < parseInt(collectionPageCount) + 1; i++) {
            urlArr.push(fetch(`/collections/${collection.handle}?view=ignore-products-data&page=${i}`).then((response) => response.json()));
          }
        } else {
          urlArr.push(fetch(`/collections/${collection.handle}?view=ignore-products-data&page=1`).then((response) => response.json()));
        }
      });

      const responses = await Promise.all(urlArr)
      return this.ignoreProducts = responses.flat()
    }

    async saveToSesseion() {
      const mySession = window.sessionStorage;
      mySession.setItem(
        "ignoreCollectionProductIds",
        JSON.stringify(this.ignoreProducts)
      );
    }
  }

  if (window.addonProduct) {
    /**
     * Checking if storedIgnoreCollectionProductIds exist, and is not an empty object
     */
    if (
      storedIgnoreCollectionProductIds &&
      JSON.stringify(storedIgnoreCollectionProductIds) !== "{}"
    ) {
      new AddonProduct({
        main: window.addonProduct,
        collectionsIgnoreProductsArr: storedIgnoreCollectionProductIds,
      });
    } else {
      new getIgnoreProductsFromCollections({ main: window.addonProduct });
    }
  }
}
